(angular => {
  "use strict";

  angular.module("Pages").controller("Pages.findRetailerCtrl", [
    "$scope",
    "$timeout",
    "$q",
    "$rootScope",
    "Loader",
    "Toast",
    "AuthService",
    "ParticipantService",
    "ActivityService",
    "$mdDialog",
    FindRetailerCtrl
  ]);

  function FindRetailerCtrl($scope, $timeout, $q, $rootScope, Loader, Toast, authService, participantService, ActivityService, $mdDialog) {
    this.event = null;
    this.activities = [];

    this.promise = Loader.add(participantService.getMarketingActivity()).then((participant) => {
      this.participant = participant;
      this.event = participant.event;
      this.marketingActivityName = participant.event.marketing_activity_name;

      for (let activity of participant.activities) {

        if (!activity.status_participant) {
          activity.subscribed = false;
          activity.status_participant = 0;
        } else if (activity.status_participant === 1) {
          activity.subscribed = true;
        }

        this.activities.push(activity);
      }
      this.online = this.event.online;
      this.banner = this.event.assets.filter(a => a.type === "banner").map(a => a.path)[0];
      this.footer = this.event.assets.filter(a => a.type === "footer").map(a => a.path)[0];

      return;
    }).catch(err => Toast.httpHandler(err));

    this.updateRestrictedList = () => {
      let participantRestricted = this.activities.map(val => ({
        id: val.restricted_list_id,
        status_participant: val.subscribed ? 1 : 0,
      }));
      const model = angular.copy(participantRestricted);
      return Loader.add(ActivityService.updateRestrictedList(model)).then(result => {
        $mdDialog.hide(result);

        if (!result.importationResult || !result.importationResult.errors.length) {
          Toast.show("Presença atualizada com sucesso", "success");

          this.sendInvite();
          return this.refreshPage();
        }
      }).catch(err => {
        Toast.httpHandler(err);
      });
    };

    this.refreshPage = () => {
      this.event = null;
      this.activities = [];

      this.promise = Loader.add(participantService.getMarketingActivity()).then((participant) => {
        this.participant = participant;
        this.event = participant.event;

        for (let activity of participant.activities) {

          if (!activity.status_participant) {
            activity.subscribed = false;
            activity.status_participant = 0;
          } else if (activity.status_participant === 1) {
            activity.subscribed = true;
          }

          this.activities.push(activity);
        }

        this.banner = this.event.assets.filter(a => a.type === "banner").map(a => a.path)[0];
        this.footer = this.event.assets.filter(a => a.type === "footer").map(a => a.path)[0];

        return;
      }).catch(err => Toast.httpHandler(err));
    };

    this.sendInvite = () => {
      const activityIds = this.activities
        .reduce((acc, group) => acc.concat(group), [])
        .filter(a => a.subscribed);

      if (!activityIds) {
        return;
      }

      if (this.event.minimum_activities > activityIds.length) {
        Toast.show(`Selecione ao menos ${this.event.minimum_activities} atividades.`, "error");
        return;
      }

      Loader.add(participantService.sendInviteActivity(activityIds)).then((msg) => {
        if (msg) {
          Toast.show(msg, "success");
        }
      }).catch(err => {
        Toast.httpHandler(err);
      });
    };
  }

})(angular);
